import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=17a215d9&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports